import { createSlice } from "@reduxjs/toolkit";
import { pending_programmes } from "../../../types/core_ibass";

export const declinedprogrammess = createSlice({
  name: "declined_programmess",
  initialState: {
    value: {
      status: false,
      pagination: [] as {
        pagination_data: {
          current_page: number;
          last_page: number;
          per_page: number;
          total: number;
          from: number;
          to: number;
        };
        data: pending_programmes;
      }[],
      data: [] as pending_programmes,
    },
  },
  reducers: {
    update_declined_programmess: (state, action) => {
      state.value.status = true;
      state.value.data = action?.payload?.data;
    },
    add_declined_programmess: (state, action) => {
      state.value.data = [...state.value.data, action?.payload];
    },
    addToDeclinedPaginationHistory: (state, action) => {
      state.value.pagination = [
        ...state.value.pagination,
        {
          pagination_data: action?.payload?.pagination_data,
          data: action?.payload?.data,
        },
      ];
    },
    remove_declined_programmess: (state, action) => {
      const { id } = action?.payload;
      const currentArray = [...state.value.data];
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => Number(v.id) === id
      );
      if (currentIndex > -1) {
        currentArray.splice(currentIndex, 1);
        state.value.data = currentArray;
      }
    },
    replace_declined_programmess: (state, action) => {
      const { id } = action?.payload;
      const currentArray = state.value.data;
      const currentIndex = currentArray.findIndex(
        (v: { id: number }) => v.id === id
      );
      currentArray.splice(currentIndex, 1, action?.payload);
      state.value.data = currentArray;
    },
    clear_declined_programmess: (state) => {
      state.value.status = false;
      state.value.data = [];
    },
  },
});

export const {
  update_declined_programmess,
  add_declined_programmess,
  addToDeclinedPaginationHistory,
  remove_declined_programmess,
  replace_declined_programmess,
  clear_declined_programmess,
} = declinedprogrammess.actions;

export default declinedprogrammess.reducer;
